import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const DELIMIT_NUMBER_OF_WORDS = 'delimit-number-of-words'
export const APPLY = 'apply'

export default {
  [PORTUGUESE]: {
    [DELIMIT_NUMBER_OF_WORDS]: 'Delimitar o número de palavras que a nuvem conterá',
    [APPLY]: 'Aplicar',
  },

  [ENGLISH]: {
    [DELIMIT_NUMBER_OF_WORDS]: 'Delimit the number of words the cloud will contain',
    [APPLY]: 'Apply',
  },

  [SPANISH]: {
    [DELIMIT_NUMBER_OF_WORDS]: 'Delimita el número de palabras que contendrá la nube',
    [APPLY]: 'Aplicar',
  },
}
